__turbopack_context__.v({
  "card": "W4hkjG_card",
  "imageBadge": "W4hkjG_imageBadge",
  "imageWrap": "W4hkjG_imageWrap",
  "imageWrapMuted": "W4hkjG_imageWrapMuted",
  "info": "W4hkjG_info",
  "link": "W4hkjG_link",
  "meta": "W4hkjG_meta",
  "poster": "W4hkjG_poster",
  "price": "W4hkjG_price",
  "scrim": "W4hkjG_scrim",
  "tagTopRight": "W4hkjG_tagTopRight",
  "title": "W4hkjG_title",
  "topLeftStack": "W4hkjG_topLeftStack",
  "topLeftStackWithBadge": "W4hkjG_topLeftStackWithBadge",
});
